import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../base'

import './notification.css'

type NotificationStatus = 'success' | 'error'

type NotificationProps = {
  closing?: boolean
  description?: string
  onClose: () => void
  status?: NotificationStatus
  title: string
}

// 触发方传入的通知内容：文案与状态由调用处提供，通知本身只负责渲染
type NotificationConfig = {
  description?: string
  // 自动消失时长（毫秒）；传 0 表示不自动消失，需手动关闭
  duration?: number
  status?: NotificationStatus
  title: string
}

const STATUS_BORDER: Record<NotificationStatus, string> = {
  error: 'border-status-danger',
  success: 'border-status-resolved',
}

const STATUS_DOT: Record<NotificationStatus, string> = {
  error: 'bg-status-danger',
  success: 'bg-status-resolved',
}

const Notification = ({
  closing,
  description,
  onClose,
  status = 'success',
  title,
}: NotificationProps) => {
  const { t } = useTranslation()
  return (
    <div
      data-slot="maxus-notification"
      className={[
        'fixed right-6 top-6 z-[70] min-h-[68px] w-[282px] rounded-lg border bg-surface-card px-4 py-3 shadow-2xl shadow-black/45',
        STATUS_BORDER[status],
        closing ? 'maxus-notification-exit-right pointer-events-none' : 'maxus-notification-enter-right',
      ].join(' ')}
    >
      <div className="flex items-start justify-between gap-3">
        <div className="flex min-w-0 gap-3">
          <span className={`mt-1.5 size-2 shrink-0 rounded-full ${STATUS_DOT[status]}`} />
          <div className="min-w-0">
            <div className="break-words text-sm font-semibold text-text-primary">{title}</div>
            {description && <div className="mt-1.5 break-words text-xs text-text-tertiary">{description}</div>}
          </div>
        </div>
        <Button aria-label={t('Close notification')} onClick={onClose} size="icon-xs" variant="ghost">
          <X className="size-4" />
        </Button>
      </div>
    </div>
  )
}

export { Notification }
export type { NotificationConfig, NotificationStatus }
